import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetBillingSystemsMutation } from '../apis';
import type { BillingSystemQueryLinkerSchema } from '../schemas';

export function BillingSystemsSelect({ disabled, ...props }: FormAsyncComboboxProps<BillingSystemQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: BillingSystemQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/billing-systems/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetBillingSystemsMutation}
      disabled={disabled}
    />
  );
}
